export const USERS_VERIFICATION_URL = '/users/verification'
